module.exports = __webpack_public_path__ + "img/coupon.26f40acd.png";